var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailCloseIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 80,
    viewBox: "0 0 24 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 12,
    height: 80,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7489 39.4117C15.0837 39.7371 15.0837 40.2655 14.7489 40.5909L10.4642 44.756C10.1294 45.0813 9.58581 45.0813 9.25106 44.756C8.91631 44.4306 8.91631 43.9021 9.25106 43.5767L12.9306 40L9.25374 36.4233C8.91899 36.0979 8.91899 35.5694 9.25374 35.244C9.58848 34.9187 10.1321 34.9187 10.4669 35.244L14.7516 39.4091L14.7489 39.4117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailCloseIco);
export default __webpack_public_path__ + "static/media/Detail_close_ico.900532ab61758834f6466de92dde33f8.svg";
export { ForwardRef as ReactComponent };